import { DealsState } from './state';

export const dealsInitialState: DealsState = {
  owned: [],
  participating: [],
};
